module.exports = __webpack_public_path__ + "img/0398388da739d3945fa1d6e2f3f32615.svg";